import { gql } from '@apollo/client';

export const getEntityAuditTrailById = gql`
  query getEntityAuditTrailById(
    $id: String!
    $types: [AuditTrailType!]
    $excludeTypes: [AuditTrailType!]
  ) {
    core {
      getEntityAuditTrails(
        id: $id
        types: $types
        excludeTypes: $excludeTypes
      ) {
        createdBy
        createdOn
        entityId
        id
        modifiedBy
        message
        modifiedOn
        title
        type
      }
    }
  }
`;
